module.exports = __webpack_public_path__ + "img/wifi-off.d57e8bac.svg";